import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./axiosConfig";
import { Heart, Store } from "lucide-react";

export default function MesFavoris() {
  const navigate = useNavigate();
  const phone = localStorage.getItem("customerPhone");

  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!phone) {
      navigate("/login-client");
      return;
    }

    api
      .get(`/users/client/${phone}/favorites`)
      .then((res) => {
        setFavorites(res.data.favorites || []);
      })
      .catch((err) => {
        console.error("❌ Erreur chargement favoris:", err);
        setFavorites([]);
      })
      .finally(() => setLoading(false));
  }, [phone, navigate]);

  const removeFavorite = async (merchantId) => {
    try {
      await api.delete(`/users/client/${phone}/favorites/${merchantId}`);
      setFavorites((prev) =>
        prev.filter((m) => String(m._id) !== String(merchantId))
      );
    } catch (err) {
      console.error("❌ Erreur suppression favori:", err);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen text-center text-gray-500 pt-28">
        Chargement de vos favoris…
      </div>
    );
  }

  return (
    <div className="min-h-screen px-4 pb-32 pt-28 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <h1 className="mb-8 text-3xl font-extrabold text-gray-800">
          ❤️ Mes supermarchés favoris
        </h1>

        {favorites.length === 0 ? (
          <div className="py-20 text-center text-gray-500">
            <Store className="mx-auto mb-4 opacity-40" size={48} />
            Aucun supermarché favori pour le moment.
          </div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
            {favorites.map((m) => (
              <div
                key={m._id}
                className="p-5 transition bg-white border shadow-sm rounded-xl hover:shadow-md"
              >
                {/* ZONE LOGO NEUTRE SANS RÉGRESSION */}
                <div className="relative flex items-center justify-center w-full h-32 mb-4 bg-gray-100 rounded-lg overflow-hidden">
                  {m.logo ? (
                    <img
                      src={m.logo.startsWith("http") ? m.logo : `https://souqi-api.onrender.com${m.logo.startsWith('/') ? '' : '/'}${m.logo}`}
                      alt={m.name}
                      className="object-contain w-full h-full"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                  ) : null}
                  
                  {/* S'affiche uniquement si pas de logo ou image cassée */}
                  <div 
                    className="flex-col items-center justify-center w-full h-full text-gray-400"
                    style={{ display: m.logo ? 'none' : 'flex' }}
                  >
                    <Store size={40} className="opacity-20" />
                    <span className="text-[10px] uppercase tracking-widest mt-2 opacity-40 font-bold">Boutique</span>
                  </div>
                </div>

                <h3 className="text-lg font-bold text-gray-800">
                  {m.name}
                </h3>

                <div className="flex items-center justify-between mt-4">
                  <button
                    onClick={() => navigate(`/boutique/${m._id}`)}
                    className="text-sm font-semibold text-[#f34141]"
                  >
                    Ouvrir →
                  </button>

                  <button
                    onClick={() => removeFavorite(m._id)}
                    className="text-red-500 hover:text-red-600"
                    title="Retirer des favoris"
                  >
                    <Heart fill="currentColor" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
